module.exports = __webpack_public_path__ + "static/media/greater-la.8cb77e76.svg";